import { Card } from "@blueprintjs/core";
import {
  faClouds,
  faIndustryAlt,
  faKey,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const CenterContainer = styled.div`
  text-align: center;
  width: 100%;
  font-size: var(--global-font-size-m);
`;

const Header = styled.div`
  font-size: 36px;
  font-weight: var(--global-font-weight-bold);
  padding-bottom: 20px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 64px 0;
  gap: 28px;
  justify-content: center;
`;

const StyledCard = styled(Card)`
  max-width: 400px;
  font-size: var(--global-font-size-s);
`;

const CardTitle = styled.div`
  font-size: var(--global-font-size-l);
  padding: 12px 0;
`;

const CardsContent = [
  {
    title: "Secure the infrastructure layer",
    text: "Find and prevent security issues in Terraform, Docker, Kubernetes, nginx, and AWS configs before they go into production.",
    icon: faClouds,
  },
  {
    title: "Find leaked secrets",
    text: "Don't leak secrets – scan every commit and ensure secrets don't make it to production.",
    icon: faKey,
  },
  {
    title: "Protect your CI/CD pipeline",
    text: "Protect the privileged CI/CD environment from malicious activity that could result in access to source code, secrets, and more.",
    icon: faIndustryAlt,
  },
];

const FindMoreBugs: React.FC = () => (
  <CenterContainer>
    <Header>Find more bugs</Header>
    <div>
      Go beyond application code and protect the entire stack with a breadth of
      scanning capabilities.
    </div>
    <CardContainer>
      {CardsContent.map((content) => (
        <StyledCard
          elevation={1}
          style={{ width: "400px" }}
          key={content.title}
        >
          <FontAwesomeIcon
            icon={content.icon}
            color="var(--global-icon-purple)"
            size="6x"
          />
          <CardTitle>{content.title}</CardTitle>
          <div>{content.text}</div>
        </StyledCard>
      ))}
    </CardContainer>
    <div>
      The possibilities are endless,{" "}
      <a href="https://r2c.dev/slack" target="_blank" rel="noopener noreferrer">
        join us on Slack
      </a>{" "}
      to share how you’re using Semgrep!
    </div>
  </CenterContainer>
);

export default FindMoreBugs;
